var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { assign } from "es6-object-assign";
import Backbone from "backbone";
import { DateTime } from "luxon";
import relayStore from "js/lib/relayStore";
import { MessageChoice, StreamChoice, FileChoice } from "js/lib/choice";
import locale from "js/lib/locale";
var Asset = /** @class */ (function (_super) {
    __extends(Asset, _super);
    function Asset(attributes, options) {
        var _this = _super.call(this, attributes, options) || this;
        // store auth info in asset
        if (options.hash && options.expire)
            _this.auth = { hash: options.hash, expire: options.expire };
        _this.interval = 30000;
        _this.intervalId = undefined;
        _this.apiUrl = options.api_url || options.apiUrl || "morty.fem.tu-ilmenau.de/femci/api/v1/";
        return _this;
    }
    Asset.prototype.update = function () {
        var _this = this;
        this.fetch({
            data: assign({ time: Date.now() }, this.auth),
            success: function () {
                _this.status = 200;
            },
            error: function (model, xhr) {
                if (!xhr) {
                    console.error("unknown fetch error");
                }
                else {
                    console.error("fetch error:", xhr.status, xhr.statusText);
                    _this.status = xhr.status;
                }
                _this.trigger("error");
            }
        });
    };
    Asset.prototype.parse = function (item) {
        // pass relays on to relayStore
        if (item.relays) {
            relayStore.set(item.relays);
            item.relays = null;
        }
        // fix spelling
        if (item.licences) {
            item.licenses = item.licences;
            delete item.licences;
        }
        return item;
    };
    Asset.prototype.startPolling = function () {
        this.intervalId = window.setInterval(this.update.bind(this), this.interval);
        this.update();
    };
    Asset.prototype.stopPolling = function () {
        clearInterval(this.intervalId);
        this.intervalId = undefined;
    };
    Asset.prototype.isProtected = function () {
        var licenses = this.get("licenses");
        return !!(licenses && licenses.protection_required);
    };
    Asset.prototype.getChoice = function () {
        var licenses = this.get("licenses"), // FIXME: change api to licenses
        files = this.get("files"), streams = this.get("streams"), images = this.get("images");
        var before_stream, current, unrestricted = [];
        var image = images && images.length ? images[0].url : undefined;
        // check for rejected license
        if (licenses && licenses.reject && licenses.reject.length) {
            var license = licenses.reject[0];
            // prefer specific reason and fallback to default reason
            var reason = !!locale.licenseReject[license] ?
                locale.licenseReject[license] : locale.licenseReject["default"];
            return new MessageChoice(reason);
        }
        // choose the first time-restricted stream that fits the current time
        if (streams && streams.length) {
            for (var i = 0; i < streams.length; i++) {
                var stream = streams[i];
                if (stream.times && stream.times[0].start) {
                    for (var j = 0; j < stream.times.length; j++) {
                        var start = stream.times[j].start * 1000, end = stream.times[j].end * 1000;
                        current = stream.times[j].current * 1000;
                        // The stream is currently running
                        if (start < current && end > current)
                            return new StreamChoice(stream.representations, image);
                        // There will be some stream in the future
                        if (start > current) {
                            before_stream = new Date(start);
                            break;
                        }
                    }
                }
                else {
                    unrestricted.push(stream);
                }
            }
        }
        if (files && files.length) {
            for (var i = 0; i < files.length; i++) {
                var file = files[i];
                if (file.url_view)
                    return new FileChoice(file.url_view, file.url_download, image, file.mimetype);
            }
        }
        if (unrestricted.length)
            return new StreamChoice(unrestricted[0].representations, image);
        if (before_stream && current) {
            var dt = DateTime.fromJSDate(before_stream);
            var now = DateTime.fromMillis(current);
            return new MessageChoice(locale.beforeStream + " " + dt.toRelative({ base: now }));
        }
        return new MessageChoice(locale.afterStream);
    };
    //@ts-ignore: Backbone executes the function to get the value
    Asset.prototype.url = function () {
        return "https://".concat(this.apiUrl, "/assets/").concat(this.get("sid"));
    };
    return Asset;
}(Backbone.Model));
;
export default Asset;
